import React, { Component } from "react";
import classnames from "classnames";

import { formatNumber } from "@formant/core/common/formatNumber";
import { ITestableComponentProps } from "@formant/core/model/ITestableComponentProps";

import { PieChart } from "../../common/PieChart";
import * as styles from "./Value.scss";

export interface IValueProps {
    size?: any;
    value?: number;
    unit?: string;
    label: string;
    invertedWarning?: boolean;
    toFixedDigits?: number;
    old?: boolean;
    className?: string;
    max?: number;
}

export class Value extends Component<IValueProps & ITestableComponentProps> {
    public render() {
        const {
            size,
            value,
            unit,
            label,
            invertedWarning,
            old,
            className,
            max,
            toFixedDigits,
        } = this.props;

        const valueString =
            value === undefined
                ? undefined
                : unit === "%" || unit === "percent"
                  ? `${max !== 1 ? value.toFixed(0) : value}%`
                  : `${formatNumber(value, undefined, 3, toFixedDigits)} ${
                        unit || ""
                    }`;

        return (
            <div
                className={classnames(
                    styles.value,
                    old && styles.old,
                    className && className,
                )}
            >
                {(unit === "%" || unit === "percent") &&
                    value !== undefined &&
                    size !== "xxxs" && (
                        <PieChart
                            value={value}
                            className={styles.pie}
                            invertedWarning={invertedWarning}
                            data-testid={`pie-chart-graph-${label}`}
                            data-value={value}
                            max={max}
                        />
                    )}
                <div className={styles.details}>
                    <div
                        className={styles.number}
                        data-testid={`stream-value-${label}`}
                        data-tooltip={valueString}
                    >
                        {valueString}
                    </div>
                    <div
                        className={styles.label}
                        data-testid={`stream-label-${label}`}
                        data-tooltip={label}
                    >
                        {label}
                    </div>
                </div>
            </div>
        );
    }
}
